<template>
  <div>
    <message-modal />
    <div>
      <main-header />
      <tabs
        ref="tabs"
        :options="{ useUrlFragment: false, defaultTabHash: 'general' }"
        class="spl-edit-tabs">
        <tab id="defaultFilter" name="Edit/Create Linehaul Drive">
          <linehaul-road-edit-page />
        </tab>
      </tabs>
      <div class="spl-linehaul-road-edit-action-bar">
        <form-button
          style="grid-column: 1"
          @onClick="handleCancel">
          Cancel
        </form-button>
        <div style="grid-column: 2" />
        <form-button
          style="grid-column: 3"
          data-cy="linehaul-road-edit-next"
          @onClick="handleNext">
          Save
        </form-button>
      </div>
      <div v-if="isLoading" class="spl-load-img" />
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import { mapState, mapMutations, mapActions } from 'vuex'
import MessageDialog from '@/components/shared/message-dialog'
import { create } from 'vue-modal-dialogs'
import { cloneDeep, isNumber } from 'lodash'
import moment from 'moment'
import store from '@/store'
const messageDialog = create(MessageDialog, 'content')

export default {
  mixins: [Helpers],
  data () {
    return {
      isLoading: false,
      activeTab: 'defaultFilter',
      tabs: ['defaultFilter'],
      linehaulRoadValues: {}
    }
  },
  computed: {
    ...mapState('linehaulRoad', ['loadedLinehaulRoad', 'currentEditLinehaulRoad'])
  },
  beforeRouteEnter (to, from, next) {
    // load the linehaulRoad before proceding when we enter an edit route
    if (to.name === 'linehaul-road-edit') {
      store.dispatch('linehaulRoad/loadLinehaulRoad', to.params.id).then(() => {
        next()
      }).catch((error) => {
        next()
        window.bus.$emit('openErrorModal', error.ExceptionMessage)
      })
    } else {
      next()
    }
  },
  created () {
    this.linehaulRoadValues = this.$route.params
    if (this.$route.name === 'linehaul-road-create' && this.linehaulRoadValues.Linehaul_Drive_Detail_Weight) {
      this.setCurrentEditLinehaulRoad({
        Linehaul_Drive_ID: this.linehaulRoadValues.Linehaul_Drive_ID,
        Linehaul_Drive_Detail_Customers: this.linehaulRoadValues.Linehaul_Drive_Detail_Customers,
        Linehaul_Drive_Detail_Parcels: this.linehaulRoadValues.Linehaul_Drive_Detail_Parcels,
        Linehaul_Drive_Detail_Weight: this.linehaulRoadValues.Linehaul_Drive_Detail_Weight,
        Linehaul_Drive_Detail_Load_Meters: this.linehaulRoadValues.Linehaul_Drive_Detail_Load_Meters,
        Linehaul_Drive_Detail_T1: this.linehaulRoadValues.Linehaul_Drive_Detail_T1,
        Linehaul_Drive_Detail_Stops: this.linehaulRoadValues.Linehaul_Drive_Detail_Stops,
        Linehaul_Drive_Detail_Date: this.linehaulRoadValues.Linehaul_Drive_Detail_Date
      })
    } else if (this.$route.name === 'linehaul-road-create' && !this.linehaulRoadValues.Linehaul_Drive_Detail_Weight) {
      // Set a default linehaulRoad when creating a new one
      this.setCurrentEditLinehaulRoad({
        Linehaul_Drive_ID: -1,
        Linehaul_Drive_Detail_Customers: '',
        Linehaul_Drive_Detail_Parcels: '',
        Linehaul_Drive_Detail_Weight: '',
        Linehaul_Drive_Detail_Load_Meters: '',
        Linehaul_Drive_Detail_T1: '',
        Linehaul_Drive_Detail_Stops: '',
        Linehaul_Drive_Detail_Date: moment().toISOString(true)
      })
    } else {
      this.setCurrentEditLinehaulRoad(cloneDeep(this.loadedLinehaulRoad))
    }
  },
  methods: {
    ...mapMutations('linehaulRoad', ['setCurrentEditLinehaulRoad']),
    ...mapActions('linehaulRoad', ['saveLinehaulRoad', 'loadLinehaulRoad']),

    // ************************ Show Login is set to true if teh user is not logged in or if the token has expired.
    validateAndSend () {
      // Validate the linehaulRoad before sending it
      var valid = true
      var validationMessage =''
      if (this.linehaulRoadMissing()) {
        valid = false
        validationMessage = 'Please enter all required values -> Linehaul Drive Weight, No. of Parcels, No. of Customers'
      }
      if (this.linehaulRoadNumberValues()) {
        valid = false
        validationMessage = 'Please check Weight and No. of Parcels, No. of Customers. At least one should have a numeric value!'
      }

      if (valid) {
        this.isLoading = true
        this.saveLinehaulRoad(this.currentEditLinehaulRoad).then((response) => {
          this.isLoading = false
          this.$router.back()
        }).catch((error) => {
          this.isLoading = false
          messageDialog('Something went wrong: ' + error.ExceptionMessage)
        })
      } else {
        messageDialog(validationMessage)
      }
    },
    linehaulRoadMissing () {
      if (!this.currentEditLinehaulRoad.Linehaul_Drive_Detail_Parcels ||
          !this.currentEditLinehaulRoad.Linehaul_Drive_Detail_Weight ||
          !this.currentEditLinehaulRoad.Linehaul_Drive_Detail_Customers) {
        return true
      }
    },
    linehaulRoadNumberValues () {
      if (isNaN(parseFloat(this.currentEditLinehaulRoad.Linehaul_Drive_Detail_Parcels)) &&
        isNaN(parseFloat(this.currentEditLinehaulRoad.Linehaul_Drive_Detail_Weight)) &&
        isNaN(parseFloat(this.currentEditLinehaulRoad.Linehaul_Drive_Detail_Customers))) {
        return true
      }
    },
    // *********************** Handle Actionbar *************************
    handleNext () {
      var linehaulRoad = cloneDeep(this.currentEditLinehaulRoad)
      linehaulRoad.Linehaul_Drive_Detail_Parcels = linehaulRoad.Linehaul_Road_Filter.Linehaul_Drive_Detail_Parcels
      linehaulRoad.Linehaul_Drive_Detail_Customers = linehaulRoad.Linehaul_Road_Filter.Linehaul_Drive_Detail_Customers
      linehaulRoad.Linehaul_Drive_ID = linehaulRoad.Linehaul_Road_Filter.Linehaul_Drive_ID.value
      linehaulRoad.Linehaul_Drive_Detail_Weight = linehaulRoad.Linehaul_Road_Filter.Linehaul_Drive_Detail_Weight
      linehaulRoad.Linehaul_Drive_Detail_Load_Meters = linehaulRoad.Linehaul_Road_Filter.Linehaul_Drive_Detail_Load_Meters
      linehaulRoad.Linehaul_Drive_Detail_T1 = linehaulRoad.Linehaul_Road_Filter.Linehaul_Drive_Detail_T1
      linehaulRoad.Linehaul_Drive_Detail_Stops = linehaulRoad.Linehaul_Road_Filter.Linehaul_Drive_Detail_Stops
      linehaulRoad.Linehaul_Drive_Detail_Date = linehaulRoad.Linehaul_Road_Filter.Linehaul_Drive_Detail_Date
      delete linehaulRoad.Linehaul_Road_Filter
      this.setCurrentEditLinehaulRoad(cloneDeep(linehaulRoad))
      this.validateAndSend()
    },
    handleCancel () {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';
  .spl-edit-tabs {
    background-color: #fff7e7;
    .tabs-component-panels {
      padding: 0 $mainPadding;
    }
    .tabs-component-tabs {
      background-color: $yellowButtonLabelHover;
      padding: 3px $mainPadding 13px $mainPadding;
      margin: 0;
      display: flex;
      .tabs-component-tab {
        color: white;
        padding-bottom: 5px;
        margin: 12px 10px 0 10px;
        list-style: none;
        font-size: 14px;
        &.is-active {
          color: #ebaa28;
          border-bottom: 2px solid #ebaa28;
        }
      }
    }
  }
</style>
